export const InitialValuesAddCategoryMarketPlace = {
	title: "",
	description: "",
}